export default {
  fr: {
    MainTitle : 'Project Tracker',
    Title : 'Suivi de projets',
    Economics : 'Économique (TOUT USD)',
    Project : "Projet",
    ProjectLeader : "Responsable",
    StatusSummary : "Statut sommaire",
    LatestUpdate : "Dernière mise-à-jour",
    ModifiedBy : 'Modifié par',
    ConfirmDelete : "Souhaitez-vous réellement supprimer ce type de mise-à-jour?",
    KPUDeleted : "La mise-à-jour a été correctement supprimé",
    ConfirmSubmission : 'Souhaitez-vous soumettre cette mise-à-jour?',
    SubmitSuccess : "La mise à jour a été correctement soumise",
    GoldPrice : "Prix de l'or utilisé", 
    AnnualProductionOz : "Prod. annuelle payable (Oz)", 
    TotalProductionOz : "Prod. totale payable (Oz)", 
    ProductionStartUpDate : "Date de mise-en-production", 
    MineLifeYears : "Durée de vie (années)", 
    InitialCapex : "Capex initial (M$)", 
    InitialCapexTooltip : "CAPEX de croissance, coûts internes et CAPEX de maintien du projet, excluant la fermeture et rémédiation ou les coûts irrécupérables",
    ExchangeRate : "Taux de change", 
    CostToFirstOunce : "Coût de 1er oz (M$)",  
    CostToFirstOunceTooltip : "Coûts totaux de CAPEX de croissance, études, incluant les coûts de forage pour obtenir la première once d'or",
    CashCost : "Cash Cost", 
    AISC : "AISC", 
    IRRStandard : "IRR à {goldPrice}$/oz et FX={fxRate}", 
    IRRAfterTax : "IRR (Après taxes)", 
    NPVAfterTax : "NPV (Après taxes) (M$)", 
    NPVStandard : "NPV à {goldPrice}$/oz et FX={fxRate} (M$)",
    StandardFXRate : "Taux de change",
    StandardGoldPrice : "Prix de l'or",
    YearlyCashFlows : "Cashflow sur 5 ans",
    YearlyCashFlowsTooltip : "SVP insérer les valeurs de flux trésoriers des 5 prochaines années incluant l’exploration, études, construction, permis, etc…  Les valeurs peuvent être des sorties (valeur négative – dépenses plus que revenue) ou des entrées (valeur positive - revenus supérieurs aux dépenses)",
    CashFlow : "Cashflow (M$)",
    CumulativeCashFlow : "Cashflow Cumul. (M$)",
    Edit : "Édition d'un suivi de projet",
    Tab1 : "Informations générales",
    Tab2 : "Économique",
    Tab3 : "Disciplines",
    Tab4 : "Challenges",
    Tab5 : "Jalons",
    Tab6 : "Opportunités",
    Tab7 : "Documents",
    OpenDocumentLibrary : "Ouvrir la bibliothèque de documents",
    NoDocumentLibrary : "Aucune bibliothèque de document associé",
    Timeline : "Chronologie",
    Report : "Rapport",
    PaginatedReport : "Rapport 'Page unique'",
    Discipline : {
      'Title' : "Disciplines",
      'Name' : "Update/Changes",
      'Comments' : "Commentaires",
      'Status' : "Statut",
      '0' : "Permis",
      '1' : "Environnement",
      '2' : "Ressource humaines",
      '3' : "Communautées",
      '4' : "Etudes",
      '5' : "Construction",
      '6' : "Mine",
      '7' : "Réserves",
      '8' : "Coûts",
      '9' : " / Géologie",
      '10' : "Exploration",
      '11' : "Autre",
      '12' : "Ingénierie",
      '13' : "Infrastructure",
      '14' : "Metallurgie",
      '15' : "Geotechnique",
      '16' : "Gestion des eaux"
    },
    ToDo : {
      Name : "Nom",
      Description : "Ajoutez une description",
      DueDate : "Date d'échéance"
    },
    Filters : {
      Title : "Filtres",
      All : "Tout",
      Completed : "Complété",
      Trashed : "Supprimés"
    },
    Challenges : {
      'Title' : "Key Challenges",
      'Add' : 'Ajouter un challenge',
      'Edit' : 'Modifier un challenge',
      'Name' : "Challenge/Risk",
      'Comments' : "Commentaires",
      'Status' : "Statut"
    },
    Milestones : {
      'Title' : "Jalons",
      'Add' : 'Ajouter un jalon',
      'Edit' : 'Modifier un jalon',
      'Name' : "Jalon",
      'Comments' : "Commentaires",
      'Status' : "Statut"
    },
    Opportunities : {
      'Title' : "Opportunités",
      'Add' : 'Ajouter une opportunité',
      'Edit' : 'Modifier une opportunité',
      'Name' : "Opportunité"
    },
    KPUStatus : {
      '0' : "Tel que prévu",
      '1' : "Suivi serré requis",
      '2' : "En retard"
    },
    Reports: {
      Title: "Rapport",
      LOM : "LOM",
      KPU : "KPU"
    },
    KeyProjectType: {
      Title : "Types de projet",
      Name : "Nom",
      IsCapitalExpenseRequest : "Dépenses en capital",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce type de projet?",
      KeyProjectTypeDeleted : "Le type de projet a été correctement supprimé",
      AddNew: "Nouveau type de project",
      Edit : "Edition d'un type de projet"
    },
    KeyProject: {
      Title : "Projets",
      ProjectName : "Nom",
      Property : 'Opération',
      District : 'Région',
      Country : 'Pays',
      IsActive : "Actif?",
      KeyProjectType : "Type de projet",
      DocumentLibraryUrl : "Lien vers la bibliothèque de document",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce projet?",
      KeyProjectDeleted : "Le projet a été correctement supprimé",
      AddNew: "Nouveau projet",
      Edit : "Edition d'un projet"
    },
    Admin: {
      Title : "Admin"
    }
  }
}
